import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../../stores/authStore';
import { USER_ROLE } from '../../../types/auth';

const SuperAdminHeaderActions = () => {
	const navigate = useNavigate();
	const { user, logout } = useAuthStore();

	const handleLogout = () => {
		logout();
		navigate('/login');
	};

	const getUserRoleDisplay = () => {
		if (!user) return '';
		switch (user.role) {
			case USER_ROLE.SUPER_ADMIN:
				return 'Super Admin';
			case USER_ROLE.SALON_OWNER:
				return 'Salon Owner';
			case USER_ROLE.STAFF:
				return 'Staff';
			default:
				return '';
		}
	};

	return (
		<div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
			<div className="text-right hidden md:block">
				<div className="font-bold text-base">{user?.name}</div>
				<div className="text-xs opacity-80">{getUserRoleDisplay()}</div>
			</div>
			<button
				onClick={handleLogout}
				className="hidden md:block bg-white/20 text-white border-2 border-white px-5 py-2.5 rounded-lg cursor-pointer font-semibold transition-all hover:bg-white hover:text-[#667eea] text-base"
			>
				Logout
			</button>
		</div>
	);
};

export default SuperAdminHeaderActions;
